<template>
  <common-warpper title="联系我们" en="CONTACT Us">
    <div class="contactUs">
      <div v-html="pageData.content"></div>
    </div>
  </common-warpper>
</template>
<script>
import CommonWarpper from "@/components/CommonWarpper.vue";
import { pageByCode } from "@/api/index";

export default {
  name: "ContactUs",
  components: {
    CommonWarpper,
  },
  data() {
    return {
      list: [],
      pageData: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      pageByCode({ pageNum: 1, pageSize: 10, code: "contact_us" }).then(
        (res) => {
          this.list = (res.data && res.data.records) || [];
          console.log(this.list);
          if (this.list.length >= 1) {
            this.pageData = this.list[0];
          }
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.contactUs {
  .info {
    padding: 5px 10px;
    ::v-deep img {
      max-width: 100%;
    }
  }
}
</style>
